import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import ResponseError from './ResponseError';

var ValidationError =
/*#__PURE__*/
function (_ResponseError) {
  _inherits(ValidationError, _ResponseError);

  function ValidationError(message, responseData, status) {
    var _this;

    _classCallCheck(this, ValidationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).call(this, message, responseData, status));
    _this.name = 'ValidationError';
    return _this;
  }

  _createClass(ValidationError, [{
    key: "getErrors",
    value: function getErrors() {
      return this.responseData;
    }
  }]);

  return ValidationError;
}(ResponseError);

export { ValidationError as default };